export const STRINGS = {
    title: "Latest Updates",
    subTitle: "Recent Updates",
};
